<template>
    <div id="smtData">
        <div class="nav">
            <ul>
                <li class="firstNav"><router-link to="/DataPage"><i class="fa fa-home"></i> 首页</router-link></li>
                <li class="firstNav">
                    <a href="#" class="showSecond"><i class="fa fa-bars"></i> XLogin</a>
                    <ul>
                        <li class="secondNav"><router-link to="/extension">推广列表</router-link></li>
                        <li class="secondNav"><router-link to="/order">订单列表</router-link></li>
                        <li class="secondNav"><router-link to="/change">修改密码</router-link></li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="dataContainer">
            <div class="header">
                <div class="logo">管理后台</div>
                <div class="user"><strong>欢迎您 <span style="color:red"> {{user}}</span> <a href="#" @click.prevent="loginOut">[注销]</a></strong></div>
            </div>
            <div class="dataArea">
                    <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data(){
        return{
            user:""
        }
    },
    created(){
        let account = sessionStorage.getItem('account')
        this.user=account
    },
    computed:{
    },
    methods:{
        loginOut:function () {
            sessionStorage.clear('token')
            this.$router.push('/login')
        },
    },
    components: {

    }
}
$(function () {
    $('.showSecond').click(function (e) {
        e.preventDefault();
        let flag=$(this).siblings('ul').css('display');
        if(flag==='block'){
            $(this).siblings('ul').slideUp();
        }else{
            $(this).siblings('ul').slideDown();
        }
    })
})
</script>

<style scoped lang="less">
    @import "../assets/less/base";
    #smtData{
        position: absolute;
        display: flex;
        width:100%;
        height:100%;
        top:0;
        left:0;
        bottom: 0;
        .nav{
            flex:0 0 200px;
            width:100px;
            height:100%;
            overflow-y: auto;
            background: @base-color;
            .firstNav{
                a{
                    display: block;
                    color:#959598;
                    height:50px;
                    line-height: 50px;
                    font-size: 14px;
                    padding-left:15px;
                    box-sizing: border-box;
                    border-left: 4px solid transparent;
                    &.router-link-exact-active{
                        background: #40532d;
                        border-left: 4px solid #99d953;
                        color: #fff;
                    }
                }
                ul a{
                    padding-left:30px;
                    &.router-link-exact-active{
                        background: #40532d;
                        color: #fff;
                    }
                }
            }
        }
        .dataContainer{
            height:100%;
            overflow-y: auto;
            width:100%;
            position: relative;
            @headerHeight:50px;
            .header{
                height:@headerHeight;
                background: #f4f4f4;
                display: flex;
                padding:0 210px 0 10px;
                box-sizing: border-box;
                position: fixed;
                top:0;
                left:200px;
                width:100%;
                z-index:100;
                .logo{
                    height:50px;line-height: 50px;
                    width:50%;
                    color:#99d953;
                    font-weight: 700;
                }
                .user{
                    width:50%;
                    line-height: 50px;
                    text-align: right;
                    font-size: 16px;
                    a{color:#09f;}
                }
            }
            .dataArea{
                padding-top:@headerHeight;
            }
        }
    }
    .phone-enter,.phone-leave-to{
        opacity: 0;
        height:0px;
        overflow: hidden;
    }
    .phone-enter-active,.phone-leave-active{
        transition: all .3s linear;
    }
</style>